import { FC } from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AuthStateProps } from 'redux/state/AuthState';
import { GlobalTypes } from 'redux/types';

export interface WrapperProps extends RouteComponentProps {
  auth: AuthStateProps;
}

const requireAuth = function (Component: FC<any>) {
  const RequireAuth: FC<WrapperProps> = ({ auth: { isAuthenticated }, ...routeProps }: WrapperProps) =>
    !isAuthenticated ? <Redirect to="/login" /> : <Component {...routeProps} />;

  const mapStateToProps = (state: GlobalTypes.RootState) => ({
    auth: state.auth,
  });

  return connect(mapStateToProps)(RequireAuth);
};
export default requireAuth;
